import produce from 'immer';
import _ from 'lodash';

import { LOCAL_STORAGE_HISTORY_ID } from 'client/constants/common';

export const getStoryLastCardId = (storyId: string): string => {
	const scHistory = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_HISTORY_ID) || '{}');
	const lastCardId = _.get(scHistory, `${storyId}.cardId`);

	return lastCardId;
};

export const updateStoryLastCardId = (storyId: string, cardId: string): void => {
	if (window.localStorage) {
		const scHistory = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_HISTORY_ID) || '{}');
		const scHistoryUpdated = produce(scHistory, draft => {
			_.set(draft, `${storyId}.cardId`, cardId);
		});
		window.localStorage.setItem(LOCAL_STORAGE_HISTORY_ID, JSON.stringify(scHistoryUpdated));
	}
};
